export default __webpack_public_path__ + "static/media/bar.5a6f5a08.png";